module.exports = __webpack_public_path__ + "img/golden.af4fc2cf.jpg";